// test741
(741 && 0);
